import { useMutation } from "@tanstack/react-query";
import { sendSupportMessage } from "../api/contact.api";
import { showToast } from "../helper/ShowToast";

export const useSendSupportMessage = () => {
    return useMutation({
        mutationFn: (body) => sendSupportMessage(body),
        onError: (err) =>
            showToast(
                "error",
                err?.response?.data?.message || "Failed to send your support request"
            ),
    });
};
